import o from "react";
import f from "classnames";
import { mintelLavender400 as b, cmDeepPurple400 as h, mintelWhite as c, mintelBlue400 as g, cmBlue400 as k, mintelBlack as m, mintelOrange200 as y, mintelRed100 as $, mintelRed400 as v } from "mintel-tokens";
import { u as N } from "./ThemeProvider--i7ESlT5.es.js";
import { u as w } from "./utils-C0l876fA.es.js";
import { T as a } from "./index-BB-Wk85r.es.js";
import { I as D } from "./Icon-BuIPTPJn.es.js";
import { u as E } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Callout.css';const R = "Callout-default-module__inline___PjTTf", T = "Callout-default-module__h1___jrhHu", B = "Callout-default-module__dark_bg___fKoJM", M = "Callout-default-module__responsive___sknvG", P = "Callout-default-module__h2___UpuBQ", G = "Callout-default-module__h3___P1IPu", H = "Callout-default-module__h4___yAeC7", Y = "Callout-default-module__h5___k-19v", j = "Callout-default-module__h6___IX9-M", q = "Callout-default-module__body___NQBu6", z = "Callout-default-module__body2___HD9sR", F = "Callout-default-module__body3___HXM1g", I = "Callout-default-module__button___bD2yW", U = "Callout-default-module__link___rY9Uw", X = "Callout-default-module__breadcrumb___cJrLu", Q = "Callout-default-module__legal___frQvV", S = "Callout-default-module__ban1___skdmb", x = "Callout-default-module__ban2___YgXT9", A = "Callout-default-module__icon___81ulz", J = "Callout-default-module__content___y7IEf", K = "Callout-default-module__dismiss___ento8", L = "Callout-default-module__error___fFE0u", O = "Callout-default-module__dark___Ogjtw", W = "Callout-default-module__warning___nbTCq", V = "Callout-default-module__info___73LuB", Z = "Callout-default-module__success___AMhUY", ee = "Callout-default-module__recommended___toNMH", r = {
  "one-line-truncation": "Callout-default-module__one-line-truncation___5BSXq",
  inline: R,
  h1: T,
  dark_bg: B,
  responsive: M,
  h2: P,
  h3: G,
  h4: H,
  h5: Y,
  h6: j,
  body: q,
  body2: z,
  body3: F,
  button: I,
  link: U,
  breadcrumb: X,
  legal: Q,
  ban1: S,
  ban2: x,
  "data-header": "Callout-default-module__data-header___t9a2j",
  "data-cell": "Callout-default-module__data-cell___eYFuH",
  "data-annotation": "Callout-default-module__data-annotation___Ra22-",
  "data-pagination": "Callout-default-module__data-pagination___VpANq",
  icon: A,
  content: J,
  dismiss: K,
  error: L,
  dark: O,
  warning: W,
  info: V,
  success: Z,
  recommended: ee
}, oe = "Callout-compere-module__inline___FZCvq", _e = "Callout-compere-module__h1___Us5Np", le = "Callout-compere-module__dark_bg___XuFf9", te = "Callout-compere-module__responsive___4NJG-", ae = "Callout-compere-module__h2___6Ows9", ne = "Callout-compere-module__h3___0Gcz5", ue = "Callout-compere-module__h4___sfmnD", de = "Callout-compere-module__h5___07XDa", ce = "Callout-compere-module__h6___rRY2C", me = "Callout-compere-module__body___0-cZf", re = "Callout-compere-module__body2___RKD-N", se = "Callout-compere-module__body3___4dffu", ie = "Callout-compere-module__button___4jm9T", Ce = "Callout-compere-module__link___--DbT", pe = "Callout-compere-module__breadcrumb___xDubP", fe = "Callout-compere-module__legal___Ohdiq", be = "Callout-compere-module__ban1___VtQRG", he = "Callout-compere-module__ban2___yELsW", ge = "Callout-compere-module__icon___Bz3cK", ke = "Callout-compere-module__content___m2ZNz", ye = "Callout-compere-module__dismiss___9-wQH", $e = "Callout-compere-module__error___dpaF5", ve = "Callout-compere-module__dark___jc8G5", Ne = "Callout-compere-module__warning___MNRiM", we = "Callout-compere-module__info___YPUuG", De = "Callout-compere-module__success___rst7C", Ee = "Callout-compere-module__recommended___YGmUS", Re = {
  "one-line-truncation": "Callout-compere-module__one-line-truncation___pRDhW",
  inline: oe,
  h1: _e,
  dark_bg: le,
  responsive: te,
  h2: ae,
  h3: ne,
  h4: ue,
  h5: de,
  h6: ce,
  body: me,
  body2: re,
  body3: se,
  button: ie,
  link: Ce,
  breadcrumb: pe,
  legal: fe,
  ban1: be,
  ban2: he,
  "data-header": "Callout-compere-module__data-header___F0rAa",
  "data-cell": "Callout-compere-module__data-cell___Gm--v",
  "data-annotation": "Callout-compere-module__data-annotation___oP3Jz",
  "data-pagination": "Callout-compere-module__data-pagination___Pqteo",
  icon: ge,
  content: ke,
  dismiss: ye,
  error: $e,
  dark: ve,
  warning: Ne,
  info: we,
  success: De,
  recommended: Ee
}, Te = { default: r, compere: Re }, Be = {
  error: (e, _) => ({
    name: "warning",
    color: _ ? $ : v,
    alt_color: _ ? m : c
  }),
  warning: () => ({
    name: "warning",
    color: y,
    alt_color: m
  }),
  info: (e) => ({
    name: "info",
    color: e === "default" ? g : k,
    alt_color: c
  }),
  success: (e) => ({
    name: e === "default" ? "green_check" : "green_check_compere"
  }),
  recommended: (e) => ({
    name: "sparkles",
    color: e === "default" ? b : h
  })
}, Fe = ({
  title: e,
  type: _,
  close: t,
  closeText: s,
  showClose: i = !1,
  children: C
}) => {
  const { t: p } = w(), n = E(), u = N(), l = Te[u] || r;
  return /* @__PURE__ */ o.createElement("div", { className: f(l[_], { [l.dark]: n }) }, /* @__PURE__ */ o.createElement(
    D,
    {
      ...Be[_](u, n),
      size: "1.25rem",
      className: l.icon
    }
  ), /* @__PURE__ */ o.createElement("div", { className: l.content }, /* @__PURE__ */ o.createElement(a.Heading5, { responsive: !0, tagName: "span" }, e), /* @__PURE__ */ o.createElement(a.Body, { responsive: !0 }, C), i && /* @__PURE__ */ o.createElement(a.Heading5, { responsive: !0, tagName: "span" }, /* @__PURE__ */ o.createElement(
    "span",
    {
      role: "button",
      onClick: t,
      onKeyDown: (d) => {
        ["Enter", "Space"].includes(d.code) && t && (t(), d.preventDefault());
      },
      tabIndex: 0,
      className: l.dismiss
    },
    s ?? p("Dismiss")
  ))));
};
export {
  Fe as C
};
